import { render } from "./SearchPostByTextContent.vue?vue&type=template&id=4ebeb912&scoped=true"
import script from "./SearchPostByTextContent.vue?vue&type=script&lang=js"
export * from "./SearchPostByTextContent.vue?vue&type=script&lang=js"

import "./SearchPostByTextContent.vue?vue&type=style&index=0&id=4ebeb912&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebeb912"]])

export default __exports__